import { sumByProperty, percentOfTotal, convertDecimalMin } from "../../helpers";

export const sumLaborSection = (subSectionLineItems, Total, cbdHeader) => {
  //TODO: rewrite and test this whole function
  const sumCostSubSection = subSection =>
    sumByProperty(subSectionLineItems[subSection], "costsheetLaborCostUsd");
  const sumObsvSubSection = subSection =>
    sumByProperty(subSectionLineItems[subSection], "costsheetTotalObservedMinutes");
  const sumStdSubSection = subSection =>
    sumByProperty(subSectionLineItems[subSection], "costsheetTotalStandardMinutes");

  const totalUpperConstruction = sumCostSubSection("Upper Construction");
  const totalUpperEmbellishment = sumCostSubSection("Upper Embellishment");
  const totalUpperPreparation = sumCostSubSection("Upper Preparation");
  const totalBottomMaking = sumCostSubSection("Bottom Making");
  const totalBottomEmbellishment = sumCostSubSection("Bottom Embellishment");
  const totalStockFit = sumCostSubSection("Stockfitting");
  const totalAssembly = sumCostSubSection("Assembly");

  const totalUpperConstructionObsv = cbdHeader.costsheetUpperConObservedLaborMinutes
    ? cbdHeader.costsheetUpperConObservedLaborMinutes
    : sumObsvSubSection("Upper Construction");
  const totalUpperEmbellishmentObsv = cbdHeader.costsheetUpperEmbObservedLaborMinutes
    ? cbdHeader.costsheetUpperEmbObservedLaborMinutes
    : sumObsvSubSection("Upper Embellishment");
  const totalUpperPreparationObsv = cbdHeader.costsheetUpperPrepObservedLaborMinutes
    ? cbdHeader.costsheetUpperPrepObservedLaborMinutes
    : sumObsvSubSection("Upper Preparation");
  const totalBottomMakingObsv = cbdHeader.costsheetBottomMakObservedLaborMinutes
    ? cbdHeader.costsheetBottomMakObservedLaborMinutes
    : sumObsvSubSection("Bottom Making");
  const totalBottomEmbellishmentObsv = cbdHeader.costsheetBottomEmbObservedLaborMinutes
    ? cbdHeader.costsheetBottomEmbObservedLaborMinutes
    : sumObsvSubSection("Bottom Embellishment");
  const totalStockFitObsv = cbdHeader.costsheetStockfittingObservedLaborMinutes
    ? cbdHeader.costsheetStockfittingObservedLaborMinutes
    : sumObsvSubSection("Stockfitting");
  const totalAssemblyObsv = cbdHeader.costsheetAssemblyObservedLaborMinutes
    ? cbdHeader.costsheetAssemblyObservedLaborMinutes
    : sumObsvSubSection("Assembly");

  const totalUpperConstructionStd = cbdHeader.costsheetUpperConStandardLaborMinutes
    ? cbdHeader.costsheetUpperConStandardLaborMinutes
    : sumStdSubSection("Upper Construction");
  const totalUpperEmbellishmentStd = cbdHeader.costsheetUpperEmbStandardLaborMinutes
    ? cbdHeader.costsheetUpperEmbStandardLaborMinutes
    : sumStdSubSection("Upper Embellishment");
  const totalUpperPreparationStd = cbdHeader.costsheetUpperPrepStandardLaborMinutes
    ? cbdHeader.costsheetUpperPrepStandardLaborMinutes
    : sumStdSubSection("Upper Preparation");
  const totalBottomMakingStd = cbdHeader.costsheetBottomMakStandardLaborMinutes
    ? cbdHeader.costsheetBottomMakStandardLaborMinutes
    : sumStdSubSection("Bottom Making");
  const totalBottomEmbellishmentStd = cbdHeader.costsheetBottomEmbStandardLaborMinutes
    ? cbdHeader.costsheetBottomEmbStandardLaborMinutes
    : sumStdSubSection("Bottom Embellishment");
  const totalStockFitStd = cbdHeader.costsheetStockfittingStandardLaborMinutes
    ? cbdHeader.costsheetStockfittingStandardLaborMinutes
    : sumStdSubSection("Stockfitting");
  const totalAssemblyStd = cbdHeader.costsheetAssemblyStandardLaborMinutes
    ? cbdHeader.costsheetAssemblyStandardLaborMinutes
    : sumStdSubSection("Assembly");

  const summedTotal =
    totalUpperConstruction +
    totalUpperEmbellishment +
    totalUpperPreparation +
    totalBottomMaking +
    totalBottomEmbellishment +
    totalStockFit +
    totalAssembly;

  const summedStandardLaborMinutes =
   totalUpperConstructionStd +
   totalUpperEmbellishmentStd +
   totalUpperPreparationStd +
   totalBottomMakingStd +
   totalBottomEmbellishmentStd +
   totalStockFitStd +
   totalAssemblyStd;
  const summedObservedLaborMinutes =
   totalUpperConstructionObsv +
   totalUpperEmbellishmentObsv +
   totalUpperPreparationObsv +
   totalBottomMakingObsv +
   totalBottomEmbellishmentObsv +
   totalStockFitObsv +
   totalAssemblyObsv;

  return [
    {
      detail: "Upper Preparation",
      std: convertDecimalMin(totalUpperPreparationStd),
      obsv: convertDecimalMin(totalUpperPreparationObsv),
      cost: totalUpperPreparation,
      percentOfTotal: percentOfTotal(Total, totalUpperPreparation)
    },
    {
      detail: "Upper Construction",
      std: convertDecimalMin(totalUpperConstructionStd),
      obsv: convertDecimalMin(totalUpperConstructionObsv),
      cost: totalUpperConstruction,
      percentOfTotal: percentOfTotal(Total, totalUpperConstruction)
    },
    {
      detail: "Upper Embellishment",
      std: convertDecimalMin(totalUpperEmbellishmentStd),
      obsv: convertDecimalMin(totalUpperEmbellishmentObsv),
      cost: totalUpperEmbellishment,
      percentOfTotal: percentOfTotal(Total, totalUpperEmbellishment)
    },
    {
      detail: "Bottom Making",
      std: convertDecimalMin(totalBottomMakingStd),
      obsv: convertDecimalMin(totalBottomMakingObsv),
      cost: totalBottomMaking,
      percentOfTotal: percentOfTotal(Total, totalBottomMaking)
    },
    {
      detail: "Bottom Embellishment",
      std: convertDecimalMin(totalBottomEmbellishmentStd),
      obsv: convertDecimalMin(totalBottomEmbellishmentObsv),
      cost: totalBottomEmbellishment,
      percentOfTotal: percentOfTotal(Total, totalBottomEmbellishment)
    },
    {
      detail: "StockFitting",
      std: convertDecimalMin(totalStockFitStd),
      obsv: convertDecimalMin(totalStockFitObsv),
      cost: totalStockFit,
      percentOfTotal: percentOfTotal(Total, totalStockFit)
    },
    {
      detail: "Assembly",
      std: convertDecimalMin(totalAssemblyStd),
      obsv: convertDecimalMin(totalAssemblyObsv),
      cost: totalAssembly,
      percentOfTotal: percentOfTotal(Total, totalAssembly)
    },
    {
      detail: "Total",
      std: convertDecimalMin(summedStandardLaborMinutes),
      obsv: convertDecimalMin(summedObservedLaborMinutes),
      cost: summedTotal,
      percentOfTotal: percentOfTotal(Total, summedTotal)
    }
  ];
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/subSectionMapping/laborSection.js